import { defineStore } from 'pinia';
import markupsService from "../services/markups.service";
export const useMarkupsStore = defineStore(
    'markups',
    {
        state: () => {
            return {
                data: {},
                query: null,
                selectedColumns: [],
                loading: false
            }
        },
        actions: {
            async fetchAll() {
                this.data = (await markupsService.fetchAll()).data;
                this.loading = true;
            },
            modifySelectedColumns(columnName) {
                if (this.selectedColumns.includes(columnName)) {
                    this.selectedColumns = this.selectedColumns.filter(c => c !== columnName);
                } else {
                    this.selectedColumns.push(columnName);
                }
            }
        },
    }
);
